import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { IconMessages } from '@tabler/icons-react';
import { useChatStore, selectSetDialog } from '@/stores/chat.store';

export function ChatEmptyState() {
  const setOpen = useChatStore(selectSetDialog);

  return (
    <div
      className={cn(
        'flex w-full flex-1 flex-col items-center justify-center rounded-md border bg-secondary p-6 shadow-sm'
      )}
    >
      <div className='flex flex-col items-center space-y-6'>
        <div className='flex h-16 w-16 items-center justify-center rounded-full border-2 border-black dark:border-white'>
          <IconMessages className='h-8 w-8' />
        </div>
        <div className='space-y-2 text-center'>
          <h1 className='text-xl font-semibold'>Suas mensagens</h1>
          <p className='text-sm text-muted-foreground'>
            Selecione uma conversa para começar ou envie uma nova mensagem.
          </p>
        </div>
        <Button
          className='gap-2'
          onClick={() => setOpen('new')}
        >
          <IconMessages size={16} />
          Enviar mensagem
        </Button>
      </div>
    </div>
  )
} 